import React from "react";
import { ElementComponentProps } from "elements/types";
import { useDisplayElement } from "components/Forms/Element";
import { useSelector } from "react-redux";
import { getOrigElementData } from "data/form/elementSelectors";
import { State } from "data";
import { HeadingElement } from "records/Element";

const Heading = ({
	fid,
	uuid,
	rowIndex,
	id,
	index,
	value,
	vid,
}: ElementComponentProps<HeadingElement>) => {
	const { eid } = useDisplayElement({ rowIndex, index, uuid });

	const _value = useSelector((state: State) => {
		if (!id) return value;
		return getOrigElementData(state, {
			fid,
			vid,
			uuid,
			rowIndex,
			id,
			index,
		})?.value;
	});

	return (
		<div className="h3 elem elem-heading" id={eid}>
			{_value}
		</div>
	);
};

export default Heading;
